// import '../scss/app.scss';
// import 'swiper/swiper-bundle.min.css';
// import '@fancyapps/ui/dist/fancybox.css';
import { Benefits, Counters, SolutionSliders } from '@/components/home';
import {
  Accordion,
  Burger,
  Clients,
  Cookies,
  Documents,
  Dropdown,
  FancyboxApp,
  FixedHeader,
  FormFile,
  FormFloatLabel,
  PageText,
  PhoneMask,
  TabLinks,
} from '@/components';
import {
  CardWorkBenefits,
  EquipmentSlider,
} from '@/components/card-work';
import { CardProductImageSlider } from '@/components/card-product';
import { AboutFeatures, AboutHistorySlider } from '@/components/about';

/*Global*/
export const tabLinks = new TabLinks();
export const clients = new Clients();
export const cookies = new Cookies();
export const dropdown = new Dropdown();
export const formFloatLabel = new FormFloatLabel();
export const formFile = new FormFile();
export const phoneMask = new PhoneMask();
export const burger = new Burger();
export const fixedHeader = new FixedHeader();
export const pageTextShowHide = new PageText();
export const accordion = new Accordion();
export const fancyboxApp = new FancyboxApp();
export const documents = new Documents();

/*Home*/
export const solutionSliders = new SolutionSliders();
export const homeCounters = new Counters();
export const benefitsMobile = new Benefits();

/*Card work*/
export const equipmentSlider = new EquipmentSlider();
export const cardWorkBenefitsMobile = new CardWorkBenefits();

/*Card Product*/
export const cardProductImageSlider = new CardProductImageSlider();

/*About*/
export const aboutFeatures = new AboutFeatures();
export const aboutHistorySlider = new AboutHistorySlider();

window.addEventListener('DOMContentLoaded', () => {
  init();
});

function init() {
  /*Global*/
  tabLinks.init();
  clients.init();
  cookies.init();
  dropdown.init();
  formFloatLabel.init();
  formFile.init();
  phoneMask.init();
  burger.init();
  fixedHeader.init();
  pageTextShowHide.init();
  accordion.init();
  fancyboxApp.init();
  documents.init();

  /*Home*/
  solutionSliders.init();
  homeCounters.init();
  benefitsMobile.init();

  /*Card work*/
  equipmentSlider.init();
  cardWorkBenefitsMobile.init();

  /*Card Product*/
  cardProductImageSlider.init();

  /*About*/
  aboutFeatures.init();
  aboutHistorySlider.init();
}
